import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon } from 'lucide-react'
import type * as React from 'react'

import { cn } from '~/shared/lib/utils'

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        // Checked state uses the brand ember accent so the checkbox matches
        // the one-accent Beacon system. Colors are taken from the `--brand`
        // tokens (which carry their own foreground per theme) rather than a
        // hardcoded literal, so contrast stays correct in light and dark.
        // Unchecked state still uses `border-input` so the border tracks the
        // theme. Override per-instance via `className` if needed.
        //
        // `dark:data-[state=checked]:bg-brand` is not redundant: Tailwind emits
        // `dark:bg-input/30` after the unqualified checked rule, so at equal
        // specificity the unchecked dark fill would win and paint a ticked box
        // in the field colour. The dark+checked pair sorts last and wins.
        'peer border-input dark:bg-input/30 data-[state=checked]:bg-brand dark:data-[state=checked]:bg-brand data-[state=checked]:text-brand-foreground data-[state=checked]:border-brand focus-visible:border-ring focus-visible:ring-brand/40 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
